import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { catchError, tap } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Router } from '@angular/router';
import { LogService } from 'src/app/shared/services/log.service';
import { Notification } from '../models/notification.model';

@Injectable({ providedIn: 'root' })
export class NotificationService {
  apiHost: string = environment.apiHost;
  constructor(
    private http: HttpClient,
    private router: Router,
    private logService: LogService
  ) {}

  readNotification(notificationId: string, userId: string): Promise<Notification> {
    let promise = new Promise<Notification>((resolve, reject) => {
      return this.http
        .get<string>(
          this.apiHost +
            '/Notification/ReadNotification?NotificationId=' +
            notificationId +
            '&userId=' + 
            userId
        )
        .toPromise()
        .then(
          (data) => {
            resolve(data['notification']);
          },
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog(
                'Admin: Get Notification',
                msg
              );
            reject(msg);
          }
        );
    });
    return promise;
  }

  viewNotifications(userId: string): Promise<Notification[]> {
    let promise = new Promise<Notification[]>((resolve, reject) => {
      return this.http
        .get<Notification[]>(
          this.apiHost +
            '/Notification/ViewNotifications?userId=' + 
            userId
        )
        .toPromise()
        .then(
          (data) => {
            resolve(data["notifications"]);
          },
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog(
                'Admin: View Notifications',
                msg
              );
            reject(msg);
          }
        );
    });
    return promise;
  }  

  deleteNotifications(userId: string, notificationIds: string[]): Promise<string> {
    let promise = new Promise<string>((resolve, reject) => {
      return this.http
        .post<string>(
          this.apiHost +
            '/Notification/DeleteNotifications?userId=' + 
            userId, notificationIds
        )
        .toPromise()
        .then(
          (data) => {
            resolve(data["result"]);
          },
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog(
                'Admin: Delete Notifications',
                msg
              );
            reject(msg);
          }
        );
    });
    return promise;
  }    
}
